import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

@autoinject
export class ConfirmDialog {
  constructor(private dialogController: DialogController) { }

  activate(options: PartialOptions) {
    Object.assign(this, new ConfirmOptions(), options);
  }

  ok() {
    this.dialogController.ok();
  }

  cancel() {
    this.dialogController.cancel();
  }
}

class ConfirmOptions {
  dialogTitle = 'Confirm';
  okTitle = 'OK';
  cancelTitle = 'Cancel';
  message: string = null;
  details: string[] = null;
  class: string = null;
  icon: string = null;
}

type PartialOptions = Partial<ConfirmOptions>;
export { PartialOptions as ConfirmOptions };
